import { getTransposedDateFirstOfMonth } from 'src/mtska-frontend-modules/modules/_shared/dashboardConfigured/dashboardDateUtils';

const withItems = (filters) => ({ items: [...(filters?.items || [])] });

const appendItems = (filters, items) => ({
    items: [...(filters?.items || []), ...items],
});

const stripField =
    (field) =>
    (filters) => ({
        items: (filters?.items || []).filter((item) => item.field !== field),
    });

export const rentalFleetFiltersTransformRegistry = {
    identity: (filters) => withItems(filters),
    rentalTimelineContractEndWindow: (filters) =>
        appendItems(filters, [
            {
                field: '_related_contract_end_at',
                operator: 'between',
                value: {
                    from: getTransposedDateFirstOfMonth(0),
                    to: getTransposedDateFirstOfMonth(11),
                },
            },
        ]),
    rentalCommissionTimelineHint: (filters) =>
        appendItems(filters, [
            {
                field: '_related_contract_start_at',
                operator: 'after',
                value: getTransposedDateFirstOfMonth(0),
            },
        ]),
    rentalKmTableStripProjected: stripField('projectedDeltaMileage'),
    rentalKmMissingRow: (filters) =>
        appendItems(stripField('projectedDeltaMileage')(filters), [
            { field: 'projectedDeltaMileage', operator: 'isEmpty', value: '_' },
        ]),
    rentalKmExcessRow: (filters) =>
        appendItems(stripField('projectedDeltaMileage')(filters), [
            { field: 'projectedDeltaMileage', operator: '>', value: 1001 },
        ]),
    rentalKmDeficitRow: (filters) =>
        appendItems(stripField('projectedDeltaMileage')(filters), [
            { field: 'projectedDeltaMileage', operator: '<', value: -1001 },
        ]),
};

export const graphComponentRegistry = {};
